import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAtTcDaty2-_ecVCIl7d3RMxBh_iL0gzVw",
  authDomain: "the-coding-studio-website.firebaseapp.com",
  projectId: "the-coding-studio-website",
  storageBucket: "the-coding-studio-website.firebasestorage.app",
  messagingSenderId: "599617919592",
  appId: "1:599617919592:web:07ab7d345a54c84657b9dd",
  measurementId: "G-Q8GTNTKE8H",
};

const app = initializeApp(firebaseConfig);

// Google Analytics is initialised lazily by analyticsLoader.ts, only after analytics consent.
export const FIREBASE_MEASUREMENT_ID = firebaseConfig.measurementId;

export default app;
